// import { apiSlice } from '@/api'
import { apiSlice } from '@/api'

export const personsChannelsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPersonsChannels: builder.query({
      query: (buildingId) => ({
        url: `api/v2/persons/channels/${buildingId}`,
        method: 'GET'
      })
    })
  })
})

export const { useGetPersonsChannelsQuery } = personsChannelsApi
